import React, { useContext, useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { useQuery } from "../../utils/useQuery";
import {
  BASE_URL_API_TRANXT_UAT_API,
  BASE_URL_PAYNOW,
} from "../../utils/Constant";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  AddBillFormEmployee,
  AddsubTask1employeeModal,
  EditTaskModal,
  FetchBillModalEmployee,
  LoanemiModal,
} from "./Modal";
import { twoDecimalPlaces } from "../../utils/utilFuctions";
import { CiReceipt } from "react-icons/ci";
import { FaBan, FaFileAlt, FaFlag } from "react-icons/fa";
import { GrEdit } from "react-icons/gr";
import { billpunchbasicauth } from "../../utils/Credentials";
import { AiFillEye } from "react-icons/ai";
import { IoMdPersonAdd } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import { SiAdblock } from "react-icons/si";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { Badge, Button, Table } from "react-bootstrap";
import { DependencyModal, Dependencytable } from "../Modal";
import Select from "react-select";
import { FcNext, FcPrevious } from "react-icons/fc";
export const ReviewBillTableEmployee = ({}) => {
  const [fetchBillModal, setFetchBillModal] = useState(false);
  const [amount, setAmount] = useState("");
  const { Profileinfo } = useContext(GlobalContext);
  const query = useQuery();

  const id = query.get("id");
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedItem, setSelectedItem] = useState(null);
  const [billerResponse, setBillerResponse] = useState({});
  const [state, setState] = useState({});
  const [fetchButtonDisable, setFetchButtonDisable] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [billPayResponse, setBillPayResponse] = useState(null);
  const [fetchButtonText, setFetchButtonText] = useState("Fetch bill");
  const [username, setUsername] = useState("Rajneesh@example.com");
  const [password, setPassword] = useState("Test@12345");
  const CustP = sessionStorage.getItem("params")
    ? JSON.parse(sessionStorage.getItem("params"))
    : [];
  const [selectedItems, setSelectedItems] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState({});

  const [showFetchModal, setShowFetchModal] = useState(false);
  const [formValues, setFormValues] = useState({
    fromDate: "",
    toDate: "",
    category: "",
    amount: "",
    minAmount: "",
    maxAmount: "",
    dateOption: "All Dates",
  });

  const fetchBill = async (biller, custParams, item) => {
    console.log("hua kuch");
    setBillerResponse({ msg: "", success: "", error: [] });
    setTransactionLoaderState(true);

    setFetchButtonDisable(true);
    setBillDetails(null);
    setBillPayResponse(null);
    setFetchButtonText("Fetching bill ...");
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username + ":" + password).toString("base64"),
    );
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      ".AspNetCore.Identity.Application=CfDJ8PA2Dduz6XVGpbQn-N2Kqq5gCNuTSX1hZVmzSqRADx47lqe6bGFocHiTHywahzfmyy_hxGzt34-c9e73A_uQhz1K_y2TKvnqIc0lLSVxenEuk9l6kzurFY1os90YhONj1qkI2AbuInUzp0l4WuKcQVbg1geMa3e35cjnGSbkRMMjfCOf7VdYuQT1xp3H4r8QBXN6CYFJLFlHp7aL0YZR-JJ3TSxrfTn-54gPPl852sLVcjFIeMOdXJTu1vpSHK9FdV93vouzmDtYSILdUCqjJ4rZ-rw-c-5Jt6wlqfj81tjbjRGTnDxMqa1y9PF8SeKzHFVmwvvB86NCfk6X12kl0Z6DwaVY2mnoalgrYPP3oEu4jZIK-QA3BE_g15RP6qDxa4g6ePtn_Bn46hjTaY6a-MN_0uydHiJ51ehGQ5eX9sFEV--g-KOo5ty5EUGD2SjX5t5zPBnPLiwOx0q2aFMu5ww8BC7u3OmsIYYHNq59zIG8plliQCkkxPaL9NX3MdnHwvziP5uQUTS0NnRynMsz86khYMnSiA1y9KL1zQKkvxQQKLp-V8F7hoAfn7K_r0yoNpHECXMkLjAv1c_9LsAzc0FNmvY9fOGtwIBIzZE2Cg1ZPB9m6IgADqBv5mUEKAfENApiWviasg1BPjtOIIJgcUdr4lpxMofSD9_b0-qJNv",
    );

    console.log(biller);
    let params = [];
    custParams.forEach((param) => {
      if (param.value && param.value != "") {
        params.push({
          name: param.paramName,
          value: param.value,
        });
      }
    });
    console.log(params);

    var raw = JSON.stringify({
      customerMobileNo: "9971407960",
      billDetails: {
        billerId: biller,
        customerParams: params,
      },
    });

    console.log(raw);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      console.log("hua");
      const res = await fetch(
        `${BASE_URL_PAYNOW}/api/Biller/BillFetch`,
        requestOptions,
      );
      const data = await res.json();

      if (data.status == "FAILURE") {
        swal("FAILURE", data.response.complianceReason, "error");
        // updatePropertyBill(item);
      } else {
        swal("Success", "Successfull", "success");
        // updatePropertyBill(item);
      }
      console.log(
        "Before updatePropertyBill call" + data.response.billerResponse,
      );
      //  updatePropertyBill(data.response,data1);

      console.log("After updatePropertyBill call");
      if (
        data.respCode == "1" &&
        data.response &&
        data.response.billerResponse &&
        data.response.billerResponse.customerName &&
        data.response.billerResponse.customerName != ""
      ) {
        setBillerResponse({
          ...billerResponse,
          error: [],
          msg: "",
        });
        setFetchBillModal(true);
        setBillDetails(data.response);
        setAmount(data.response.billerResponse.amount);
      } else if (
        data.respCode == "0" &&
        data.response &&
        data.response.errorList &&
        data.response.errorList.length > 0
      ) {
        setBillerResponse({
          ...billerResponse,
          error: data.response.errorList,
          msg: "",
        });
      } else {
        setBillerResponse({
          ...billerResponse,
          error: [],
          msg: "Something went wrong",
        });
      }
      setTransactionLoaderState(false);
      setFetchButtonDisable(false);
      setFetchButtonText("Fetch bill");
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
      setFetchButtonDisable(false);
      setFetchButtonText("Fetch bill");
    }
  };

  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const getAllPropertyBills = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        id: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getfirmBills`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        console.log(data.data);
        setData(data.data);
        setData1(data.data);
        setTransactionLoaderState(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const updatePropertyBill = async (item, data12) => {
    console.log(data1 + "123");
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        b_id: data12.id,
        firmid: user.firm_id,
        service: data12.service,
        provider: data12.provider,
        consumerid: data12.consumerid,
        mobile: Profileinfo?.mobile,
        month: item.billerResponse.billDate,
        amount: item.billerResponse.amount,
        refno: item.refId,
        paramslist: JSON.stringify(data12.paramsList),
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/updateSalaryBill`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        getAllPropertyBills();
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    getAllPropertyBills();
  }, [id]);

  const handleItemSelection = (item) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((selectedItem) => selectedItem !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };
  const { accessDataemp } = useContext(GlobalContext);
  useEffect(() => {
    console.log("Access Data:", accessDataemp);
  }, [accessDataemp]);

  return (
    <>
      <FetchBillModalEmployee
        fetchBillModal={fetchBillModal}
        setFetchBillModal={setFetchBillModal}
        billDetails={billDetails}
        billerResponse={billerResponse}
        callback={() => {}}
        billPayResponse={billPayResponse}
        setAmount={() => {}}
        amount={amount}
        setTpin={() => {}}
        Tpin={"0"}
        config={{ amountEditable: false }}
      />
      <AddBillFormEmployee
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        getAllPropertyBills={getAllPropertyBills}
      />
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <h4 className="mx-2 my-1">Bills</h4>

        {accessDataemp &&
          accessDataemp.map(
            (module) =>
              module.data &&
              module.data.map((role) =>
                role.role_name === "Add Bills" ? (
                  role.access === "Y" ? (
                    <span key={role.pk_role_id} className="my-1">
                      <Link style={{ textDecoration: "none" }}>
                        <button
                          type="button"
                          className="btn btn-sm d-flex align-items-center justify-content-center"
                          style={{
                            background: "#2ca01c",
                            borderRadius: ".4em",
                            height: "2rem",
                            width: "7rem",
                            border: "none",
                            color: "#fff",
                          }}
                          onClick={handleShowModal}
                        >
                          Add Biller
                        </button>
                      </Link>
                    </span>
                  ) : (
                    <span key={role.pk_role_id} className="my-1">
                      <button
                        className="btn btn-sm"
                        style={{
                          color: "#fff",
                          height: "2rem",
                          border: "none",
                          borderRadius: ".4rem",
                          fontSize: ".8rem",
                          backgroundColor: "gray",
                          cursor: "not-allowed",
                        }}
                        disabled
                      >
                        Add Biller
                      </button>
                    </span>
                  )
                ) : null,
              ),
          )}
      </div>

      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "30px" }}
      >
        <table
          className="PMS-collection-table m-1"
          style={{
            textAlign: "center",
            overflow: "hidden",
            borderRadius: ".4rem",
          }}
        >
          <thead>
            <tr>
              <th style={{ color: "#0074D9" }}>Services</th>
              <th style={{ color: "#0074D9" }}>Provider</th>
              <th style={{ color: "#0074D9" }}>Bill Date</th>
              <th style={{ color: "#0074D9" }}> Consumer ID </th>
              <th style={{ color: "#0074D9" }}>Amount</th>
              <th
                style={{
                  color: "#0074D9",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td>{item.service}</td>
                  <td>{item.provider}</td>
                  <td>{new Date(item.month).toLocaleDateString()}</td>
                  <td>{item.consumerid}</td>
                  <td>{twoDecimalPlaces(item.amount)}</td>
                  <td className="d-flex justify-content-center">
                    <div style={{ marginRight: "10px" }}>
                      <div
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "white",
                          color: "#0074D9",
                          border: "1px solid #0074D9",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={() => {
                          console.log("ni hua");
                          fetchBill(item.provider, item.paramsList);
                        }}
                      >
                        Fetch & Pay
                      </div>
                    </div>
                    <div style={{ marginRight: "10px" }}>
                      <div
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "white",
                          color: "#0074D9",
                          border: "1px solid #0074D9",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2rem",
                          width: "6rem",
                        }}
                        onClick={() => {
                          updatePropertyBill(billDetails, item);
                        }}
                      >
                        Update
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export const ViewExpenseTableEmployee = ({ data }) => {
  return (
    <>
      <div className=" m-0 ">
        <div className="row">
          <div className="col-12">
            <div
              className="table-responsive"
              style={{ borderRadius: ".4em", border: "1px solid lightgrey" }}
            >
              <table className="table table-bordered m-0 p-0 ">
                <thead>
                  <tr style={{ borderBottom: "1px solid lightgrey" }}>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      ID
                    </th>

                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Type
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Date
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Amount
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Description
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Approve(HR)
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Approve(Admin)
                    </th>
                    <th
                      className="text-center"
                      style={{
                        color: "#0074D9",
                        background: "#fff",
                        border: "none",
                      }}
                    >
                      Receipt
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr
                        style={{ borderBottom: "1px solid lightgrey" }}
                        key={index}
                      >
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.pk_expense_id}
                        </td>

                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.expense_type}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {new Date(item.expense_date).toLocaleDateString()}
                        </td>

                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {twoDecimalPlaces(item.expense_amount)}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.description}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.approved_by_hr === "R" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 46, 46, 0.1)",
                                color: "#ff2e2e",
                                border: "1px solid #ff2e2e",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Rejected
                            </span>
                          )}
                          {item.approved_by_hr === "P" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 255, 0, 0.1)",
                                color: " #f7b12a",
                                border: "1px solid #f7b12a",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Pending
                            </span>
                          )}
                          {item.approved_by_hr === "A" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(43, 193, 85, 0.1)",
                                color: "#2bc155",
                                border: "1px solid #2bc155",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Approved
                            </span>
                          )}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          {item.approved_by_admin === "R" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 46, 46, 0.1)",
                                color: "#ff2e2e",
                                border: "1px solid #ff2e2e",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Rejected
                            </span>
                          )}
                          {item.approved_by_admin === "P" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(255, 255, 0, 0.1)",
                                color: " #f7b12a",
                                border: "1px solid #f7b12a",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Pending
                            </span>
                          )}
                          {item.approved_by_admin === "A" && (
                            <span
                              className=" p-1 "
                              style={{
                                backgroundColor: "rgba(43, 193, 85, 0.1)",
                                color: "#2bc155",
                                border: "1px solid #2bc155",
                                borderRadius: ".3rem",
                                fontSize: ".8rem",
                              }}
                            >
                              Approved
                            </span>
                          )}
                        </td>
                        <td
                          className="text-center align-middle"
                          style={{ border: "none", fontSize: ".9rem" }}
                        >
                          <a
                            href={item.baseurl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CiReceipt style={{ fontSize: "2rem" }} />
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export const Tasklist = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [taskdata, setTaskData] = useState([]);
  const [PriorityFilter, setPriorityFilter] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [platformFilter, setPlatformFilter] = useState(null);
  const { password, username } = billpunchbasicauth;

  const [categories, setCategories] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [showaddsubtaskModal, setshowaddsubtaskModal] = useState(false);
  const [showdependency, setshowdependency] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [Dependencymodal, setDependencymodal] = useState(false);
  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [dependencyTaskId, setDependencyTaskId] = useState(null);
  const [currentTaskId, setCurrentTaskId] = useState(null);

  const opendependency = () => {
    setDependencymodal(true);
  };

  const closedependency = () => {
    setDependencymodal(false);
  };
  const openaddsubtaskModal = () => {
    setshowaddsubtaskModal(true);
  };
  const closeaddsubtaskModal = () => {
    setshowaddsubtaskModal(false);
  };
  const opendependencymodal = (taskId) => {
    setDependencyTaskId(taskId);
    setshowdependency(true);
    setCurrentTaskId(taskId);
  };

  const closedependencymodal = () => {
    setshowdependency(false);
  };

  const taskdataobject = JSON.parse(sessionStorage.getItem("taskdata"));
  console.log(taskdataobject, "taskdataobject");
  const propertyobject = JSON.parse(sessionStorage.getItem("property"));
  const fetchCategories = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firmid: user.firm_id }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetCatTask`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const fetchedCategories = data.data.map((cat) => ({
          value: cat.pk_catid,
          label: cat.catname,
        }));
        setCategories(fetchedCategories);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleCategoryChange = (selectedOption) => {
    setCategoryFilter(selectedOption);
  };
  const getTask = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        spaceid: propertyobject.pk_work_id,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setTaskData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const [status, setstatus] = useState();
  const Updatestatus = async (spaceID, taskId) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        spaceid: spaceID,
        projectid: propertyobject.pk_project_id,
        taskid: taskId,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/ChangeTaskStatus`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setstatus(data.data);
        getTask();
        swal("Success", data.result, "success");
      } else {
        swal("Error", data.msg, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const options = [
    {
      value: "Urgent",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "maroon" }} />
          Urgent
        </div>
      ),
    },
    {
      value: "High",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "#f4c430" }} />
          High
        </div>
      ),
    },
    {
      value: "Normal",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "blue" }} />
          Normal
        </div>
      ),
    },
    {
      value: "Low",
      label: (
        <div>
          <FaFlag style={{ marginRight: "5px", color: "grey" }} />
          Low
        </div>
      ),
    },
    {
      value: "Clear",
      label: (
        <div>
          {" "}
          <img
            src={require("../../assets/images/flag_1.png")}
            style={{ marginRight: "5px", width: ".8rem" }}
          />
          Clear
        </div>
      ),
    },
  ];
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const fetchPlatforms = async () => {
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ taskid: "string" }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetTaskPlatform`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        const fetchedPlatforms = data.data.map((device) => ({
          value: device.pk_platformid,
          label: device.platform_name,
        }));
        setPlatforms(fetchedPlatforms);
      }
    } catch (error) {
      console.error("Error fetching platforms:", error);
    }
  };
  const handlePlatformChange = (selectedOption) => {
    setPlatformFilter(selectedOption);
  };

  useEffect(() => {
    getTask();
    fetchPlatforms();
    fetchCategories();
  }, []);
  const { accessDataemp } = useContext(GlobalContext);
  useEffect(() => {
    console.log("Access Data:", accessDataemp);
  }, [accessDataemp]);
  const popoverStyle = {
    background: "#fff",
    width: "15vw",
    position: "absolute",
    zIndex: 1,
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
  };

  const filteredTaskData = taskdata
    .filter((item) => {
      const priorityMatch =
        !PriorityFilter ||
        PriorityFilter.value === "Clear" ||
        item.task_priority === PriorityFilter.value;
      const platformMatch =
        !platformFilter ||
        platformFilter.value === "clear" ||
        item.platform === platformFilter.label;
      const categoryMatch =
        !categoryFilter ||
        categoryFilter.value === "clear" ||
        item.category === categoryFilter.label;
      const searchMatch =
        searchQuery === "" ||
        item.taskname.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.task_description
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        item.task_startdate.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.task_enddate.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.platform.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.task_assignee.toLowerCase().includes(searchQuery.toLowerCase());
      return priorityMatch && platformMatch && searchMatch && categoryMatch;
    })
    .sort((a, b) => new Date(b.task_startdate) - new Date(a.task_startdate));
  const [selectedTask, setSelectedTask] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const handleEditClick = (item) => {
    setSelectedTask(item);
    setShowModal(true);
    console.log(item);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handledelete = async (taskId) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this task!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const base64Credentials = btoa(`${username}:${password}`);

          const raw = JSON.stringify({
            taskid: taskId,
            projectid: propertyobject.pk_project_id,
          });

          const requestOptions = {
            method: "POST",
            headers: {
              Authorization: `Basic ${base64Credentials}`,
              "Content-Type": "application/json",
            },
            body: raw,
            redirect: "follow",
          };

          const res = await fetch(
            `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/DeleteTaskEmployee`,
            requestOptions,
          );
          const data = await res.json();
          if (data.status === "1") {
            swal("Error", data.msg, "error");
          } else {
            swal("Success", data.msg, "success");
            setTransactionLoaderState(false);
            getTask();
          }
          handleClose();
        } catch (error) {
          console.log("Error:", error);
        }
      } else {
        swal("Your task is safe!");
      }
    });
  };
  const formatDescription = (description) => {
    return description
      .split("\n")
      .map((point, index) => <li key={index}>{point}</li>);
  };
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");

  return (
    <div className="" style={{ background: "" }}>
      <AddsubTask1employeeModal
        show={showaddsubtaskModal}
        closeModal={closeaddsubtaskModal}
        getSubsubTask={getTask}
        pk_work_id={propertyobject.pk_work_id}
        pk_project_id={propertyobject.pk_project_id}
      />
      <DependencyModal
        show={Dependencymodal}
        closeModal={closedependency}
        getTask={getTask}
      />
      <Dependencytable
        taskId={currentTaskId}
        show={showdependency}
        closeModal={closedependencymodal}
        dependencyTaskId={dependencyTaskId}
      />
      <div className="row align-items-center g-2">
        <div className="col-auto">
          <Select
            placeholder="Priority"
            className="w-100"
            options={options}
            value={PriorityFilter}
            onChange={(selectedOption) => setPriorityFilter(selectedOption)}
          />
        </div>

        <div className="col-auto">
          <Select
            placeholder="Platform"
            className="w-100"
            options={[{ value: "clear", label: "Clear" }, ...platforms]}
            value={platformFilter}
            onChange={handlePlatformChange}
          />
        </div>

        <div className="col-auto">
          <Select
            placeholder="Category"
            className="w-100"
            options={[{ value: "clear", label: "Clear" }, ...categories]}
            value={categoryFilter}
            onChange={handleCategoryChange}
          />
        </div>

        <div className="col">
          <input
            className="form-control"
            type="text"
            placeholder="Search Task..."
            value={searchQuery}
            onChange={handleSearchChange}
            style={{ width: "16rem" }}
          />
        </div>

        <div className="col-auto">
          {accessDataemp &&
            accessDataemp.map(
              (module) =>
                module.data &&
                module.data.map((role) =>
                  role.role_name === "Create Task" ? (
                    role.access === "Y" ? (
                      <span key={role.pk_role_id}>
                        <Badge
                          className="d-flex align-items-center px-2"
                          style={{
                            border: "1px solid blue",
                            background: "azure",
                            height: "2rem",
                            cursor: "pointer",
                          }}
                          onClick={openaddsubtaskModal}
                        >
                          Add Task
                        </Badge>
                      </span>
                    ) : (
                      <span key={role.pk_role_id}>
                        <button
                          className="btn btn-sm btn-secondary"
                          style={{
                            height: "2rem",
                            fontSize: ".8rem",
                            cursor: "not-allowed",
                          }}
                          disabled
                        >
                          Add Task
                        </button>
                      </span>
                    )
                  ) : null,
                ),
            )}
        </div>
      </div>

      <div
        className="table-responsive "
        style={{
          borderRadius: ".4em",
          border: "1px solid lightgrey",
        }}
      >
        <table className="table table-striped">
          <thead style={{ position: "sticky", top: 0, background: "#fff" }}>
            <tr>
              <th
                style={{
                  borderBottom: "1px solid #f2f4f2",
                  color: "#000",
                  background: "#fff",
                  padding: "8px",
                  textAlign: "left",
                  width: "45%",
                }}
              >
                Description
              </th>

              <th
                style={{
                  borderBottom: "1px solid #f2f4f2",
                  color: "#000",
                  background: "#fff",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                Date
              </th>

              <th
                style={{
                  borderBottom: "1px solid #f2f4f2",
                  color: "#000",
                  background: "#fff",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                Assignee
              </th>
              <th
                style={{
                  borderBottom: "1px solid #f2f4f2",
                  color: "#000",
                  background: "#fff",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                File
              </th>
              <th
                style={{
                  borderBottom: "1px solid #f2f4f2",
                  color: "#000",
                  background: "#fff",
                  padding: "8px",
                  textAlign: "left",
                }}
              >
                Status
              </th>
              <th
                style={{
                  borderBottom: "1px solid #f2f4f2",
                  color: "#000",
                  background: "#fff",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredTaskData.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  className="text-center"
                  style={{ padding: "8px" }}
                >
                  No data found
                </td>
              </tr>
            ) : (
              filteredTaskData.map((item) => (
                <React.Fragment key={item.pk_task_id}>
                  <tr
                    style={{
                      border: "none",
                      cursor: "pointer",
                      background: "#fff",
                    }}
                  >
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                      }}
                    >
                      {item.task_priority === "High" && (
                        <FaFlag
                          style={{ marginRight: "5px", color: "#f4c430" }}
                        />
                      )}
                      {item.task_priority === "Urgent" && (
                        <FaFlag
                          style={{ marginRight: "5px", color: "maroon" }}
                        />
                      )}
                      {item.task_priority === "Normal" && (
                        <FaFlag style={{ marginRight: "5px", color: "blue" }} />
                      )}
                      {item.task_priority === "Low" && (
                        <FaFlag style={{ marginRight: "5px", color: "grey" }} />
                      )}
                      {item.task_priority === "Clear" && (
                        <img
                          src={require("../../assets/images/flag_1.png")}
                          style={{ marginRight: "5px", width: ".8rem" }}
                          alt="Clear Flag"
                        />
                      )}
                      {item.taskname} &nbsp;
                      {item.dependency_status === "Y" && (
                        <span
                          className="p-1"
                          style={{
                            color: "#135D66",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <SiAdblock
                            style={{ fontSize: "1.4rem" }}
                            onClick={() => {
                              console.log(item.pk_taskid, "dependencytask id");
                              opendependencymodal(item.pk_taskid);
                            }}
                          />
                        </span>
                      )}
                      ({item.platform})
                      <br />
                      <Link
                        to="/Employee/Subtask"
                        onClick={() => {
                          sessionStorage.setItem(
                            "taskdetails",
                            JSON.stringify(item),
                          );
                        }}
                      >
                        <ul className="m-0" style={{ fontSize: ".8rem" }}>
                          {formatDescription(item.task_description)}
                        </ul>
                      </Link>
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                      }}
                    >
                      {new Date(item.task_startdate).getDate()}{" "}
                      {new Date(item.task_startdate).toLocaleString("default", {
                        month: "long",
                      })}{" "}
                      - {new Date(item.task_enddate).getDate()}{" "}
                      {new Date(item.task_enddate).toLocaleString("default", {
                        month: "long",
                      })}{" "}
                      {new Date(item.task_enddate).getFullYear()}
                    </td>

                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                      }}
                    >
                      {item.task_assignee}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                      }}
                    >
                      {item.issue === null ? (
                        <FaBan
                          style={{ fontSize: "1.3rem", color: "red" }}
                          title="No Data"
                        />
                      ) : item.issue?.trim() ? (
                        <FaFileAlt
                          style={{
                            fontSize: "1.3rem",
                            color: "green",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(item.issue, "_blank")}
                        />
                      ) : null}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontSize: ".8rem",
                      }}
                    >
                      {item.status === "O" && (
                        <span
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(255, 46, 46, 0.1)",
                            color: "#ff2e2e",
                            border: "1px solid #ff2e2e",
                            borderRadius: ".3rem",
                          }}
                        >
                          Overdue
                        </span>
                      )}
                      {item.status === "P" && (
                        <span
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(255, 255, 0, 0.1)",
                            color: "#f7b12a",
                            border: "1px solid #f7b12a",
                            borderRadius: ".3rem",
                          }}
                        >
                          Pending
                        </span>
                      )}
                      {item.status === "C" && (
                        <span
                          className="p-1"
                          style={{
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "#2bc155",
                            border: "1px solid #2bc155",
                            borderRadius: ".3rem",
                          }}
                        >
                          Complete
                        </span>
                      )}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                        className="adminemp-tooltip-container"
                        onClick={() =>
                          Updatestatus(item.fk_spaceid, item.pk_taskid)
                        }
                      >
                        <IoCheckmarkDoneCircle
                          style={{ fontSize: "1.5rem", color: "green" }}
                        />
                        <span className="adminemp-tooltip-text">
                          Mark Complete
                        </span>
                      </div>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                        className="adminemp-tooltip-container"
                      >
                        <GrEdit
                          style={{ fontSize: "1.2rem", color: "#6482AD" }}
                          onClick={() => handleEditClick(item)}
                        />
                        <span className="adminemp-tooltip-text">Edit</span>
                      </div>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                        className="adminemp-tooltip-container"
                      >
                        <MdDeleteForever
                          style={{ fontSize: "1.5rem", color: "red" }}
                          onClick={() => handledelete(item.pk_taskid)}
                        />
                        <span className="adminemp-tooltip-text">Delete</span>
                      </div>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                        className="adminemp-tooltip-container"
                        onClick={() => {
                          sessionStorage.setItem(
                            "dependencytaskid",
                            JSON.stringify(item),
                          );
                          opendependency();
                        }}
                      >
                        <IoMdPersonAdd
                          style={{ fontSize: "1.5rem", color: "green" }}
                        />
                        <span className="adminemp-tooltip-text">
                          Add
                          <br /> Dependency
                        </span>
                      </div>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                        className="adminemp-tooltip-container"
                        onClick={() => opendependencymodal(item.pk_taskid)}
                      >
                        <AiFillEye
                          style={{ fontSize: "1.5rem", color: "#6482AD" }}
                        />
                        <span className="adminemp-tooltip-text">
                          View <br />
                          Dependency
                        </span>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))
            )}
          </tbody>
        </table>
      </div>
      <EditTaskModal
        showModal={showModal}
        handleClose={handleClose}
        selectedTask={selectedTask}
        setSelectedTask={setSelectedTask}
        pk_project_id={propertyobject.pk_project_id}
        pk_work_id={propertyobject.pk_work_id}
        getTask={getTask}
      />
    </div>
  );
};
export const ShopTable = ({ shopData }) => {
  return (
    <Table bordered hover responsive>
      <thead>
        <tr>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Shop Name
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Location
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Shop Mobile
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Owner Name
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Owner Mobile
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            GST
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Type
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Pincode
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Details
          </th>
        </tr>
      </thead>
      <tbody>
        {shopData.map((shop, index) => (
          <tr key={shop.id || index}>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_name}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_location}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_mobile}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.owner_name}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.owner_mobile}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_gst}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_type}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_pincode}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {shop.shop_details}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
export const Employeetable = ({ employeedata }) => {
  return (
    <Table bordered hover responsive>
      <thead>
        <tr>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Name
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Mobile / Email
          </th>

          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Designation
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Joining Date
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            DOB
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Shop Name
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Shift
          </th>
          <th
            className="text-center"
            style={{
              color: "#0074D9",
              background: "#fff",
              border: "none",
            }}
          >
            Bank
          </th>
        </tr>
      </thead>
      <tbody>
        {employeedata.map((emp, index) => (
          <tr key={emp.id || index}>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.name}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.mobile}
              <br />
              {emp.email}
            </td>

            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.designation}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.joining_date?.split("T")[0]}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.dob?.split("T")[0]}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.shop_name}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.shift}
            </td>
            <td
              className="text-center align-middle"
              style={{ border: "none", fontSize: ".9rem" }}
            >
              {emp.bank_name}
              <br />
              {emp.bank_accno}
              <br /> {emp.bank_ifsc}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

// export const DocsComponent = ({}) => {
//   const [content, setContent] = useState("");
//   const { password, username } = billpunchbasicauth;

//   const modules = {
//     toolbar: [
//       [{ header: [1, 2, 3, 4, 5, 6, false] }],
//       ["bold", "italic", "underline", "strike"],
//       [{ color: [] }, { background: [] }],
//       [{ script: "sub" }, { script: "super" }],
//       ["link", { image: "Upload Image" }],
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ indent: "-1" }, { indent: "+1" }],
//       [{ align: [] }],
//       ["clean"],
//       [{ save: "Save" }],
//     ],
//   };

//   let quillRef;
//   const handleSaveAsPDF = () => {
//     console.log(handleSaveAsPDF, "doc");
//     const element = document.getElementById("quill-content");
//     html2canvas(element).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF();
//       const width = pdf.internal.pageSize.getWidth();
//       const height = pdf.internal.pageSize.getHeight();
//       pdf.addImage(imgData, "PNG", 0, 0, width, height);
//       pdf.save("document.pdf");
//     });
//   };
//   const handleToolbarClick = (value) => {
//     if (value === "save") {
//       handleSaveAsPDF();
//     }
//   };

//   return (
//     <>
//       <ReactQuill
//         id="quill-content"
//         ref={(el) => {
//           if (el) quillRef = el;
//         }}
//         theme="snow"
//         value={content}
//         onChange={setContent}
//         modules={modules}
//         formats={[
//           "header",
//           "bold",
//           "italic",
//           "underline",
//           "strike",
//           "color",
//           "background",
//           "script",
//           "link",
//           "image",
//           "list",
//           "bullet",
//           "indent",
//           "align",
//         ]}
//         toolbarHandlers={{
//           save: handleToolbarClick,
//         }}
//       />{" "}
//       <div style={{ marginTop: "10px" }}>
//         <button onClick={handleSaveAsPDF}>Save As PDF</button>
//       </div>
//     </>
//   );
// };

export const SubTasklist = () => {
  const taskdetails = JSON.parse(sessionStorage.getItem("taskdetails"));
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;

  const [taskdata, setTaskData] = useState([]);
  const getTask = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username + ":" + password).toString("base64"),
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        taskid: taskdetails.pk_taskid,
        platformid: "1",
        categoryid: "1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetSubTask`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setTaskData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getTask();
  }, []);

  return (
    <div>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          tableLayout: "fixed",
        }}
      >
        {" "}
        <thead
          style={{
            position: "sticky",
            top: 0,
            // zIndex: 1,
            background: "#fff",
          }}
        >
          <tr>
            <th
              style={{
                borderBottom: "1px solid #f2f4f2",
                color: "#000",
                padding: "8px",
                textAlign: "left",
                background: "#fff",
              }}
            >
              Task Name
            </th>
            <th
              style={{
                borderBottom: "1px solid #f2f4f2",
                color: "#000",
                padding: "8px",
                textAlign: "left",
                background: "#fff",
              }}
            >
              Assignee
            </th>
            <th
              style={{
                borderBottom: "1px solid #f2f4f2",
                color: "#000",
                padding: "8px",
                textAlign: "center",
                background: "#fff",
              }}
            >
              Status
            </th>
          </tr>
        </thead>
        {taskdata.length === 0 ? (
          <tr>
            <td colSpan="3" style={{ textAlign: "center", padding: "8px" }}>
              No data found
            </td>
          </tr>
        ) : (
          <tbody>
            {taskdata.slice(0, 5).map((item, index) => (
              <React.Fragment key={item.pk_task_id}>
                <tr key={item.pk_task_id}>
                  <td
                    style={{
                      textAlign: "left",
                      border: "none",
                      fontSize: ".9rem",
                      filter: index === 4 ? "blur(2px)" : "none",
                    }}
                  >
                    {" "}
                    {item.priority === "High" && (
                      <FaFlag
                        style={{ marginRight: "5px", color: "#f4c430" }}
                      />
                    )}
                    {item.priority === "Urgent" && (
                      <FaFlag style={{ marginRight: "5px", color: "maroon" }} />
                    )}
                    {item.priority === "Normal" && (
                      <FaFlag style={{ marginRight: "5px", color: "blue" }} />
                    )}
                    {item.priority === "Low" && (
                      <FaFlag style={{ marginRight: "5px", color: "grey" }} />
                    )}
                    {item.priority === "Clear" && (
                      <img
                        src={require("../../assets/images/flag_1.png")}
                        style={{ marginRight: "5px", width: ".8rem" }}
                      />
                    )}
                    {item.sub_name} &nbsp;
                  </td>
                  <td
                    style={{
                      textAlign: "left",
                      border: "none",
                      fontSize: ".9rem",
                      filter: index === 4 ? "blur(2px)" : "none",
                    }}
                  >
                    {item.sub_empname} &nbsp;
                  </td>

                  <td
                    style={{
                      textAlign: "center",
                      border: "none",
                      fontSize: ".9rem",
                      filter: index === 4 ? "blur(2px)" : "none",
                    }}
                  >
                    {" "}
                    {item.status === "O" && (
                      <span
                        className=" p-1 "
                        style={{
                          backgroundColor: "rgba(255, 46, 46, 0.1)",
                          color: "#ff2e2e",
                          border: "1px solid #ff2e2e",
                          borderRadius: ".3rem",
                        }}
                      >
                        Overdue
                      </span>
                    )}
                    {item.status === "P" && (
                      <span
                        className=" p-1 "
                        style={{
                          backgroundColor: "rgba(255, 255, 0, 0.1)",
                          color: " #f7b12a",
                          border: "1px solid #f7b12a",
                          borderRadius: ".3rem",
                        }}
                      >
                        Pending
                      </span>
                    )}
                    {item.status === "C" && (
                      <span
                        className=" p-1 "
                        style={{
                          backgroundColor: "rgba(43, 193, 85, 0.1)",
                          color: "#2bc155",
                          border: "1px solid #2bc155",
                          borderRadius: ".3rem",
                        }}
                      >
                        Complete
                      </span>
                    )}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        )}
      </table>
      <div className="d-flex justify-content-center">
        <Link to="/Employee/Subtasks">
          <FcPrevious />
          View More
          <FcNext />
        </Link>
      </div>
    </div>
  );
};
export const PayrollTable = ({ data, fetchpayrolldata }) => {
  const { password, username } = billpunchbasicauth;
  const [clickedRows, setClickedRows] = useState([]);
  const [rows, setRows] = useState(data);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedServiceType, setSelectedServiceType] = useState({});
  useEffect(() => {
    setRows(data);
  }, [data]);
  const handleProcessAll = async (
    fk_empid,
    amount,
    bank_accno,
    bank_ifsc,
    bank_name,
    mobile,
    name,
    month,
  ) => {
    setTransactionLoaderState(true);

    let transactionMode = selectedServiceType?.[fk_empid] || "IMPS";
    const client = Number(user.firm_id) === 6 ? "GROWNPE" : "BUMPPY";

    if (clickedRows.includes(fk_empid)) {
      swal("Error", "Button already clicked for this row", "error");
      return;
    }

    const sanitize = (value) =>
      typeof value === "string" ? value.trim() : value;

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const payload = {
        id: fk_empid,
        firmid: user.firm_id,
        purpose: "SALARY",
        userid: fk_empid,
        amount: amount,
        tpin: "1",
        serviceType: transactionMode,
        accNo: sanitize(bank_accno),
        ifsc: sanitize(bank_ifsc),
        bankName: sanitize(bank_name),
        mobile,
        custName: name,
        month,
        client: client,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/SalaryManagement/SalaryPayroll`,
        requestOptions,
      );

      const result = await response.json();
      if (result.status === "0") {
        swal("Success", result.msg, "success");
        setRows((prev) =>
          prev.map((row) =>
            row.fk_empid === fk_empid ? { ...row, status: "Success" } : row,
          ),
        );
        fetchpayrolldata();
      } else {
        swal("Error", result.msg, "error");
        setRows((prev) =>
          prev.map((row) =>
            row.fk_empid === fk_empid ? { ...row, status: "Failed" } : row,
          ),
        );
        fetchpayrolldata();
      }

      setTransactionLoaderState(false);
      setClickedRows((prev) => [...prev, fk_empid]);
    } catch (error) {
      swal("API call failed", "An error occurred", "error");
      setTransactionLoaderState(false);
    }
  };

  return (
    <Table bordered hover size="sm">
      <thead>
        <tr>
          <th className="text-center">Employee</th>
          <th className="text-center">Mobile</th>
          <th className="text-center">Designation</th>
          <th className="text-center">Shop Name</th>
          <th className="text-center">Shop Location</th>
          <th className="text-center">Bank</th>
          <th className="text-center">Pay Days</th>
          <th className="text-center">Amount</th>
          <th className="text-center">Status</th>
          <th className="text-center">Pay</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? (
          rows.map((item) => (
            <tr key={item.fk_empid + item.from_date}>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.name}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.mobile}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.designation}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.shop_name}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.shop_location}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.bank_name}
                <br /> {item.bank_accno}
                <br /> {item.bank_ifsc}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.pay_days}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.amount}
              </td>
              <td
                className="text-center align-middle"
                style={{ fontSize: ".9rem" }}
              >
                {item.status === "P" ? (
                  <span className="p-1" style={{ color: "#f7b12a" }}>
                    Pending
                  </span>
                ) : (
                  item.status
                )}
              </td>
              <td className="text-center align-middle">
                {item.status === "P" ? (
                  <Button
                    size="sm"
                    onClick={() =>
                      handleProcessAll(
                        item.fk_empid,
                        item.amount,
                        item.bank_accno,
                        item.bank_ifsc,
                        item.bank_name,
                        item.mobile,
                        item.name,
                        item.month,
                      )
                    }
                    disabled={item.hold_status === "Y"}
                  >
                    Process
                  </Button>
                ) : (
                  <Button size="sm" disabled>
                    Processed
                  </Button>
                )}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="14" style={{ textAlign: "center" }}>
              No payroll data found
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export const LoanTable = ({ loanList }) => {
  const formatMonthYear = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleString("default", { month: "short", year: "numeric" });
  };
  return (
    <div className="table-responsive">
      <table
        className="table table-sm align-middle mb-0"
        style={{ fontSize: "0.9rem" }}
      >
        <thead style={{ background: "#f1f3f5" }}>
          <tr>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>Salary</th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>
              Loan Amount
            </th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>EMI Amount</th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>
              File Charge
            </th>

            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>Loan Date</th>

            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>Tenure</th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>Start </th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>End </th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>Status</th>
          </tr>
        </thead>

        <tbody>
          {loanList.length > 0 ? (
            loanList.map((item, index) => (
              <React.Fragment key={item.id}>
                <tr>
                  <td
                    style={{ fontSize: ".9rem" }}
                    className="text-primary fw-semibold"
                  >
                    ₹{item.salary}
                  </td>
                  <td style={{ fontSize: ".9rem" }} className="fw-semibold">
                    ₹{item.total_loan}
                  </td>
                  <td style={{ fontSize: ".9rem" }} className="fw-semibold">
                    ₹{item.loan_emi_amount}
                  </td>
                  <td style={{ fontSize: ".9rem" }}>
                    ₹{item.loan_file_charge}
                  </td>
                  <td style={{ fontSize: ".9rem" }}>
                    {item.loan_disbursement_date?.split("T")[0]}
                  </td>
                  <td style={{ fontSize: ".9rem" }}>
                    <span className="badge bg-light text-dark border">
                      {item.emi_tenure} Month
                    </span>
                  </td>
                  <td style={{ fontSize: ".9rem" }}>
                    {formatMonthYear(item.start_date)}
                  </td>
                  <td style={{ fontSize: ".9rem" }}>
                    {formatMonthYear(item.end_date)}
                  </td>
                  <td style={{ fontSize: "1rem" }}>
                    {item.is_active === "P" ? (
                      <span className="badge bg-warning text-dark">
                        Pending for Approval
                      </span>
                    ) : item.is_active === "Y" ? (
                      <span className="badge bg-success">Approved</span>
                    ) : (
                      <span className="badge bg-danger">Rejected</span>
                    )}
                  </td>
                </tr>
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan="10" className="text-center py-4 text-muted">
                No Loan Records Found for
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
export const MyLoanTable = ({ myloanList = [] }) => {
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN");
  };

  const formatMonthYear = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return d.toLocaleString("default", { month: "short", year: "numeric" });
  };

  const handleViewEMI = (loan) => {
    setSelectedLoan(loan);
    setShowModal(true);
  };
  return (
    <div className="table-responsive">
      <table
        className="table table-sm align-middle mb-0"
        style={{ fontSize: "0.9rem" }}
      >
        <thead style={{ background: "#f1f3f5" }}>
          <tr>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>
              Loan Amount
            </th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>EMI Amount</th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>
              File Charge
            </th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>Loan Date</th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>Tenure</th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>Start</th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>End</th>
            <th style={{ fontWeight: "400", fontSize: ".9rem" }}>Status</th>
            <th style={{ fontSize: ".9rem", fontWeight: "400" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {myloanList?.length > 0 ? (
            myloanList.map((item) => (
              <tr key={item.id}>
                <td
                  style={{ fontSize: ".9rem" }}
                  className="text-primary fw-semibold"
                >
                  ₹{item.total_loan}
                </td>

                <td style={{ fontSize: ".9rem" }} className="fw-semibold">
                  ₹{item.loan_emi_amount}
                </td>

                <td style={{ fontSize: ".9rem" }}>₹{item.loan_file_charge}</td>

                <td style={{ fontSize: ".9rem" }}>
                  {formatDate(item.loan_disbursement_date)}
                </td>

                <td style={{ fontSize: ".9rem" }}>
                  <span className="badge bg-light text-dark border">
                    {item.emi_tenure} Month
                  </span>
                </td>

                <td style={{ fontSize: ".9rem" }}>
                  {formatMonthYear(item.start_date)}
                </td>

                {/* End Date */}
                <td style={{ fontSize: ".9rem" }}>
                  {formatMonthYear(item.end_date)}
                </td>

                <td style={{ fontSize: ".9rem" }}>
                  {item.is_active === "P" ? (
                    <span className="badge bg-warning text-dark">Pending</span>
                  ) : item.is_active === "Y" ? (
                    <span className="badge bg-success">Approved</span>
                  ) : (
                    <span className="badge bg-danger">Rejected</span>
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleViewEMI(item)}
                  >
                    View EMI
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center py-4 text-muted">
                No Loan Records Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <LoanemiModal
        showModal={showModal}
        setShowModal={setShowModal}
        selectedLoan={selectedLoan}
      />
    </div>
  );
};
